import { useQuery } from '@tanstack/react-query';

import { getTeamLeagueDetailsInfoController } from '@/interface-adapters/controllers/get-team-league-details-info.controller';
import { useOrganizationStore } from '@/store/organization-store';

export const useTeamLeagueDetailsQuery = (teamLeagueUuid: string, organizationId?: string) => {
	const store = useOrganizationStore();
	return useQuery({
		queryKey: ['TEAM_LEAGUE_DETAILS', organizationId || store.organizationUuid, teamLeagueUuid],
		queryFn: () => getTeamLeagueDetailsInfoController(teamLeagueUuid, organizationId || store.organizationUuid),
		enabled: !!((organizationId || store.organizationUuid) && teamLeagueUuid)
	});
};
